import React, { useState } from "react";
import { finishLogin } from "../../../../services/firebase";
import {
  fetchClinicianCustomToken,
  parseCustomTokenResponse,
} from "../../../../services/clinicianLoginSession";
import { MESSAGES_TYPES, USER_TYPES } from "../../../../assets/appConstants";
import { postMessage } from "../../../../services/utils";
import RegistrationWizardState from "../registrationWizardState";

const SuccessStep = ({ demo = false }) => {
  const [signingIn, setSigningIn] = useState(false);
  const [signedIn, setSignedIn] = useState(false);
  const [error, setError] = useState("");

  const handleSignIn = async () => {
    if (signingIn || signedIn) return;

    setSigningIn(true);
    setError("");

    try {
      const account = RegistrationWizardState.getAccount();
      const accountId = account.accountId;

      if (demo) {
        setSignedIn(true);
        return;
      }

      const subAccountId = account.subAccountId;
      const tokenRes = subAccountId
        ? await fetchClinicianCustomToken(subAccountId)
        : null;
      const customToken =
        parseCustomTokenResponse(tokenRes) ||
        parseCustomTokenResponse(account.loginData?.customToken);

      const loginData = {
        accountId,
        accountType: account.accountType || USER_TYPES.THERAPIST,
        customToken,
        subAccountId: subAccountId || account.subAccountId || null,
        encryptedAccountId:
          account.loginData?.encryptedAccountId ||
          subAccountId ||
          account.subAccountId ||
          accountId,
        accountData: null,
        immediateRedirect: true,
        registrationCompleted: true,
      };

      finishLogin(loginData);
      postMessage(MESSAGES_TYPES.HIDE_PRELOADER);
      setSignedIn(true);
    } catch (e) {
      setError("Could not complete sign in. Please try again.");
    } finally {
      setSigningIn(false);
    }
  };

  return (
    <div className="clinician-onboard-success">
      <div className="clinician-onboard-success__icon">✓</div>
      <h2 className="clinician-onboard-title">Welcome aboard</h2>
      <p className="clinician-onboard-subtitle">
        {signedIn
          ? "You're signed in. You can continue in the app."
          : "Your clinician profile is ready. Sign in to continue."}
      </p>
      {error && (
        <p className="clinician-onboard-field-error" role="alert">
          {error}
        </p>
      )}
      {!signedIn && (
        <button
          type="button"
          className="clinician-onboard-success__cta"
          onClick={handleSignIn}
          disabled={signingIn}
        >
          {signingIn ? "Signing in..." : "Sign in"}
        </button>
      )}
    </div>
  );
};

export default SuccessStep;
